module.exports = __webpack_public_path__ + "static/media/icon.5f5602e0.png";